import {
  LINK_ACCEPTABLE_USE_POLICY,
  LINK_BILLING_POLICY,
  LINK_MESSAGING_SERVICE_AGREEMENT,
  LINK_PRIVACY_POLICY,
  LINK_SECURITY_INFORMATION,
  LINK_TERMS_OF_USE,
} from 'shared/constants/links'

export class FooterSectionStore {
  get links() {
    return [
      {
        label: 'Terms & Conditions',
        key: 'termsAndConditions',
        url: LINK_MESSAGING_SERVICE_AGREEMENT,
      },
      {
        label: 'Terms of Use',
        key: 'termsOfUse',
        url: LINK_TERMS_OF_USE,
      },
      {
        label: 'Privacy Policy',
        key: 'privacyPolicy',
        url: LINK_PRIVACY_POLICY,
      },
      {
        label: 'Billing Policy',
        key: 'billingPolicy',
        url: LINK_BILLING_POLICY,
      },
      {
        label: 'Acceptable Use Policy',
        key: 'acceptableUsePolicy',
        url: LINK_ACCEPTABLE_USE_POLICY,
      },
      {
        label: 'Security & Privacy',
        key: 'securityAndPrivacy',
        url: LINK_SECURITY_INFORMATION,
      },
    ]
  }
}
